'use client';
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import SplideSlider from '@components/SplideSlider';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
interface SliderItem {
  url: string;
  mobileUrl?: string;
  alt?: string;
  label?: string;
}
interface CommonDynamicSliderProps {
  data: SliderItem[];
  width?: number;
  height?: number;
  options?: any;
  className?: string;
  contentClassName?: string;
  imageClassName?: string;
  children?: React.ReactNode | ((currentSlide: SliderItem) => React.ReactNode);
}
export default function CommonDynamicSlider({
  data = [],
  width = 768,
  height = 768,
  options,
  className,
  contentClassName,
  imageClassName,
  children,
}: CommonDynamicSliderProps) {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const currentSlide = data[currentSlideIndex] || data[0] || {};
  const defaultOptions = {
    type: 'loop',
    rewind: false,
    pagination: true,
    arrows: true,
    autoplay: true,
    speed: 2000,
    interval: 6000,
    ...options,
  };
  return (
    <Box className={`${cn.dynamicSliderBanner} ${className}`}>
      <SplideSlider
        showArrows
        prevArrow={<ArrowLeftIcon />}
        nextArrow={<ArrowRightIcon />}
        arrowsClassName={cn.dynamicSliderArrow}
        prevClassName={cn.dynamicSliderArrowPrev}
        nextClassName={cn.dynamicSliderArrowNext}
        options={defaultOptions}
        onSlideChange={(index: number) => {
          setCurrentSlideIndex(index);
        }}
      >
        {data.map((item: SliderItem, index: number) => (
          <Box
            key={index}
            className={`${cn.dynamicSliderBlock} ${imageClassName}`}
          >
            <Mobile>
              <CustomImage
                src={item?.mobileUrl || ''}
                alt={item?.alt || ''}
                width={width}
                height={height}
              />
            </Mobile>
            <Desktop>
              <CustomImage
                src={item?.url || ''}
                alt={item?.alt || ''}
                width={width}
                height={height}
              />
            </Desktop>
          </Box>
        ))}
      </SplideSlider>
      {typeof children === 'function' ? (
        <Box className={`${cn.dynamicSliderContent} ${contentClassName}`}>
          {children(currentSlide)}
        </Box>
      ) : children ? (
        <Box className={`${cn.dynamicSliderContent} ${contentClassName}`}>
          {children}
        </Box>
      ) : null}
    </Box>
  );
}
